<script setup lang="ts">
import type { MmaSessionFragmentFragment } from '~/graphql/mma/generated/graphql';

defineProps<{
  user: MmaSessionFragmentFragment;
}>();
</script>

<template>
  <div
    class="fixed top-0 left-0 right-0 text-center bg-red-500 text-white p-1 font-bold z-60"
  >
    Impersonating {{ user.__typename }}: {{ user.first_name }} {{ user.last_name }}
    | {{ user.contactPrimaryEmail?.value || 'No email' }} ... Logout when finished
  </div>
</template>
